/* GiftHub: after a quick add (collection "Choose options" panel), open the cart drawer like the product page does.
   The theme only flashes a small "Added to cart" banner inside the quick-add panel, which shoppers miss. */
(() => {
  if (window.ghCartUx) return;
  window.ghCartUx = true;
  document.addEventListener('on:cart:add', (e) => {
    const t = e.target;
    if (!(t instanceof Element) || !t.closest('quick-add-drawer')) return;
    if (!window.theme || theme.settings.afterAtc !== 'drawer') return;
    // product-form.js re-renders the drawer contents 700ms after the add; open just after that.
    setTimeout(() => document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open')), 800);
  });
})();
